import { render, staticRenderFns } from "./RecurringOrderDaySelector.vue?vue&type=template&id=0bba0cf7&"
import script from "./RecurringOrderDaySelector.vue?vue&type=script&lang=ts&"
export * from "./RecurringOrderDaySelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports